import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Autocomplete,
  Pagination,
  TextField,
  IconButton,
  Button,
  Typography,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { baseUrl } from "../config/api-config";
import useErrorHandler from "../hooks/useErrorHandler";
import { v4 as uuidv4 } from "uuid";
import { RotateRight } from "@mui/icons-material";
// import { makeStyles } from "@mui/styles";
// //import { makeStyles } from "@material-ui/core/styles";

// const useStyles = makeStyles(() => ({
//   // stands for .MuiAutocomplete-option
//   option: {
//     fontSize: "12px",
//   },
// }));
const DropdownEditableTable = ({ caseId, onValueChange }) => {
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState(null);
  const [open, setOpen] = useState(true);
  const [offset, setOffset] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const { data: user } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const errorHandler = useErrorHandler();
  const limit = 10; // Number of options to display per page

  useEffect(() => {
    fetchOptions();
  }, [offset, inputValue]);

  const fetchOptions = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${baseUrl}/users/list/${caseId}?limit=${limit}&offset=${offset}&name=${inputValue}`,
        {
          headers: {
            authorization: user.token,
          },
        }
      );
      const data = await response.json();
      setOptions((prevOptions) => {
        if (offset === 0) {
          const dataValue = [...data.data];

          return dataValue;
        } else {
          const dataValue = [...prevOptions, ...data.data];

          return dataValue;
        }
      });
      setLoading(false);
    } catch (error) {
      errorHandler(error);
    }
  };

  const handleSelect = (event, option) => {
    setValue(option);
    onValueChange(option);
    setOffset(0);
    setOptions([]);
    setOpen(false);
  };

  const handlePageChange = async () => {
    setOffset((prev) => {
      return prev + 1;
    });
  };
  useEffect(() => {
    if (inputValue === "") {
      setOptions([]);
      setOpen(true);
    }
  }, [inputValue]);
  const renderInput = (params) => (
    <div>
      <TextField
        size="small"
        {...params}
        label="Select "
        variant="outlined"
        onChange={(event) => {
          setOffset(0);
          setOptions([]);
          setInputValue(event.target.value);
        }}
        value={inputValue}
        className="editTextBox"
        InputProps={{
          style: { fontSize: 12 },
          ...params.InputProps,
          endAdornment: (
            <>
              {loading ? <CircularProgress color="inherit" size={20} /> : null}
              {params.InputProps.endAdornment}
              <Button
                className="quote-load-more-button !max-w-[30px] !max-h-[28px] !min-w-[30px]"
                // disabled={inputValue !== "" ? true : false}
                onClick={() => {
                  if (options.length === 10) {
                    handlePageChange();
                  }
                  return;
                }}
                              >
                {/* //  Load More */}
                <RotateRight />
              </Button>
            </>
          ),
        }}
        autoFocus
      />
    </div>
  );

  const handleClose = () => {
    setOpen(false);
  };
  //   const classes = useStyles();
  return (
    <div>
      <Autocomplete
        open={open}
        // classes={{ option: classes.option }}
        fullWidth
        options={options}
        getOptionLabel={(option) => option.name}
        //getOptionLabel={getOptionLabel}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
          // handle arrow button click here
          if (newInputValue.endsWith("")) {
            console.log("lenghth", options.length);
            // handle arrow button click here
            setOpen(true); // open the options list
          }
        }}
        renderInput={renderInput}
        value={value}
        onChange={handleSelect}
        size="small"
        className="mt-3"
      />
      {/* <Pagination count={totalPages} onChange={handlePageChange} /> */}
    </div>
  );
};

export default DropdownEditableTable;
